import { Component, Prop } from 'vue-property-decorator'
import { KhAnimationProps, KhText, Nullable } from '@internal-libraries/kheops-ui-lib'
import { DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT } from '../../const'
import ClvrScreenControlCellAbstract from '../ClvrScreenControlCellAbstract'
import { DEFAULT_HEIGHT_CONTAINER } from '../../../../const'
import ScreenResolutionHelper from '../../../../../../system/vue/Classes/ScreenResolutionHelper'

@Component({
    components: {
        KhText,
    },
})
export default class ClvrScreenControlMaterialCell extends ClvrScreenControlCellAbstract {
    @Prop({ type: String, default: '' })
    public text!: string

    public get directiveAnimationRightToLeft(): Nullable<KhAnimationProps> {
        return !this.printMode
            ? {
                  ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
                  text: this.text,
                  containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER),
              }
            : null
    }
}
